import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
// import Layout from './views/layout/Layout'
// import { getToken, setToken } from '@/utils/auth' // getToken from cookie

NProgress.configure({ showSpinner: false }); // NProgress Configuration

export const whiteList = [
  "Landing Page",
  "Login",
  "Demo",
  "Public-NanoVerify",
  "Public-GrapheneVerify",
  "Public-NanoTrust",
  "Public-NT-NanoMark",
  "forgot-password",
  "reset-password",
  "email-confirmation",
  "email-pending",
  "privacy-policy"
]; // no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start(); // start progress bar

  if (localStorage.LuxTag) {
    // console.log('Getting token from cookies: ', getToken())
    if (JSON.parse(localStorage.LuxTag).user.token) {
      // setToken(JSON.parse(localStorage.LuxTag).user.token)
      // determine if there has token
      /* has token*/
      // console.log('JSON.parse(localStorage.LuxTag).user.token', JSON.parse(localStorage.LuxTag).user.token)
      if (to.path === "/") {
        next({ name: "Public-NanoVerify" });
        NProgress.done(); // if current page is dashboard will not trigger	afterEach hook, so manually handle it
      } else {
        if (!store.getters.permission_routers) {
          // store.dispatch('GetInfo').then(res => { // user_info
          store
            .dispatch(
              "GenerateRoutes",
              JSON.parse(localStorage.LuxTag).user.name
            )
            .then(() => {
              // roles
              router.addRoutes(store.getters.addRouters);
              next({ ...to, replace: true }); // hack addRoutes ,set the replace: true so the navigation will not leave a history record
              // next()
              // })
            })
            .catch(err => {
              store.dispatch("LogOut").then(() => {
                if (whiteList.includes(to.name)) {
                  // Hack to close not authenticated message
                  Message.closeAll();
                  next();
                } else {
                  Message.error(
                    err || "Verification failed, please login again"
                  );
                  next({ name: "Public-NanoVerify" });
                }
              });
            });
        } else {
          next();
        }
      }
    } else {
      // console.log('inside localStorage but no Token')
      /* has no token*/
      if (whiteList.includes(to.name)) {
        next();
      } else {
        next("/NanoVerify");
        NProgress.done(); // if current page is login will not trigger afterEach hook, so manually handle it
      }
    }
  } else {
    // console.log('No localstorage, check of localstorage failed')

    /* has no token*/
    if (whiteList.includes(to.name)) {
      // console.log('No name present')
      next();
    } else {
      // console.log('No storage so redirecting to Login page')

      next("/NanoVerify");
      NProgress.done(); // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // finish progress bar
});



// WEBPACK FOOTER //
// ./src/permission.js